import React, { createContext, useContext, useState } from 'react';
import { menuService } from '../services/menu.service';

type SidebarMenu = {
  items: {
    label: string;
    path: string;
  }[];
};

type SidebarContextType = {
  menu: SidebarMenu;
  setMenu: (menu: SidebarMenu) => void;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  updateMenu: (menuId: number) => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [menu, setMenu] = useState<SidebarMenu>({ items: [] });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const updateMenu = (menuId: number) => {
    menuService.getLeftMenu(menuId).then((res) => {
      setMenu({
        items: (res.data.data ?? []).map((item: any) => ({
          label: item.name,
          path: item.route
        }))
      });
    }).catch((err) => {
      console.log(err);
    })
  };

  return (
    <SidebarContext.Provider value={{ menu, setMenu, isSidebarOpen, toggleSidebar, updateMenu }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}; 